import apiRequest from './apiRequest';

const emailTemplateApi = {
    // Get all templates
    getAllTemplates(token) {
        return apiRequest('/api/email/templates', 'GET', token);
    },

    // Get template by ID
    getTemplateById(templateId, token) {
        return apiRequest(`/api/email/templates/${templateId}`, 'GET', token);
    },

    // Get template by name
    getTemplateByName(templateName, token) {
        return apiRequest(`/api/email/templates/name/${templateName}`, 'GET', token);
    },

    // Get templates by type
    getTemplatesByType(emailType, token) {
        return apiRequest(`/api/email/templates/type/${emailType}`, 'GET', token);
    },

    // Get active templates
    getActiveTemplates(token) {
        return apiRequest('/api/email/templates/active', 'GET', token);
    },

    // Create template
    createTemplate(data, token) {
        return apiRequest('/api/email/templates', 'POST', token, data);
    },

    // Update template
    updateTemplate(templateId, data, token) {
        return apiRequest(`/api/email/templates/${templateId}`, 'PUT', token, data);
    },

    // Toggle template status
    toggleTemplateStatus(templateId, token) {
        return apiRequest(`/api/email/templates/${templateId}/toggle`, 'PATCH', token);
    },

    // Delete template
    deleteTemplate(templateId, token) {
        return apiRequest(`/api/email/templates/${templateId}`, 'DELETE', token);
    },

    // Preview template
    previewTemplate(data, token) {
        return apiRequest('/api/email/templates/preview', 'POST', token, data);
    },

    // Send test email
    sendTestEmail(templateId, testEmail, token) {
        return apiRequest(`/api/email/templates/${templateId}/test`, 'POST', token, { testEmail });
    }
};

export default emailTemplateApi;
